/**
 * Clickable Title Component Constants
 * All magic numbers and configuration values
 */

export const CLICKABLE_TITLE_CONSTANTS = {
  /** Gap between title and caret in mobile view */
  MOBILE_GAP: 5,

  /** Gap between title and caret in tablet view */
  TABLET_GAP: 4,

  /** Gap between title and caret in desktop view */
  DESKTOP_GAP: 3,

  /** Mobile font size in pixels */
  MOBILE_FONT_SIZE: 28,

  /** Desktop font size in pixels */
  DESKTOP_FONT_SIZE: 42,

  /** Caret icon base size */
  CARET_SIZE: 16,

  /** Caret scale factor for mobile */
  CARET_MOBILE_SCALE: 0.875,

  /** Caret scale factor for desktop */
  CARET_DESKTOP_SCALE: 1,
} as const;
